// settings/HamburgerMenu/sections/VoiceSection.tsx
import React, { useEffect, useState } from "react";
import { useAtom } from "jotai";
import Accordion from "~/components/utils/Accordion";
import VoiceSettings from "../../VoiceSettings";
import { languageAtom } from "~/Atom";
import { getVRMName, getVRMGlobalName } from "~/vrm_utils/VRMUtils";
import { useTranslation } from "react-i18next";
import { useVoiceSettings } from "../hooks/useVoiceSettings";
import { VRM } from "@pixiv/three-vrm";
import { currentLocale } from "~/Commons";

interface VoiceSectionProps {
  loadedVrm: VRM | null;
  isExpression: boolean;
}

const VoiceSection: React.FC<VoiceSectionProps> = ({ loadedVrm, isExpression }) => {
  const { t } = useTranslation();
  const [language] = useAtom(languageAtom);
  const [characterName, setCharacterName] = useState("");
  const { updateSliderValue, isVoiceReady } = useVoiceSettings(loadedVrm);

  useEffect(() => {
    const fetchCharacterName = async () => {
      let cachedName = getVRMName(loadedVrm);
      if (language !== currentLocale) {
        cachedName = await getVRMGlobalName(loadedVrm);
      }
      setCharacterName(cachedName.replace(/\(.*?\)/g, ""));
    };

    fetchCharacterName();
  }, [loadedVrm, language]);

  return (
    <Accordion
      items={[
        {
          title: `${t("voiceSettings")}${isVoiceReady ? `(${characterName})` : ""}`,
          content: (
            <VoiceSettings
              updateSliderValue={updateSliderValue}
              loadedVrm={loadedVrm}
              isVoiceReady={isVoiceReady}
              isExpression={isExpression}
            />
          ),
          dynamicHeight: true,
        },
      ]}
    />
  );
};

export default VoiceSection;
